import * as moment from 'moment'
import { Link } from 'react-router-dom'
import ReactTable, { CellInfo } from 'react-table'
import LocalizationStore from '../Stores/LocalizationStore'
import * as React from 'react'
import HttpActionsService from '../Services/HttpActionsService'
import QuestionnairesStore from '../Stores/QuestionnairesStore'
import {
    IQuestionnaire,
    getQuestionnaireStatusClass,
    getQuestionnaireStatusTextForList,
    QuestionnaireStatus,
    Questionnaire,
    FindQRequest,
} from './Questionnaire'
import PhoneHelper from '../Helpers/PhoneHelper'
import ProductHelper, { getProductsSum } from '../Helpers/ProductHelper'
import * as _ from 'lodash'
import DateTimeHelper from '../Helpers/DateTimeHelper'
import CommentHelper from '../Helpers/CommentHelper'
import EnumHelpers from '../Helpers/EnumHelpers'
import ConfigStore from '../Stores/ConfigStore'
import {
    getPaymentSchedule,
    getPaymentPerMonth,
    getCreditBodySum,
    getLastPenaltyAmountFromList,
    getCurrentDebtByCreditBody,
    getCurrentDebt,
    getPaymentsSum,
    getFeeSum
} from '../Helpers/PaymentScheduleHelper'
import UserStore from '../Stores/UserStore'
import { toJS } from 'mobx'
import * as FontAwesome from 'react-icons/lib/fa'
import { TroubleEventType } from './TroubleEvent'
import { CancelReason } from './CancelReasonModel'

export class QuestionnaireTableItem {

    constructor(questionnaire: Questionnaire) {

        let scheduleArr = getPaymentSchedule(questionnaire.credit.creditCondition.paymentsScheduleJson)
        let penalty = getLastPenaltyAmountFromList(questionnaire.credit.penalties)

        this.id = questionnaire.id
        this.date = moment(questionnaire.createDate!.toString()).format('DD.MM.YYYY')

        this.name = `${null === questionnaire.client.surname ? '' : questionnaire.client.surname}` +
            ` ${null === questionnaire.client.name ? '' : questionnaire.client.name}` +
            ` ${null === questionnaire.client.middleName ? '' : questionnaire.client.middleName}`
        this.sum = getProductsSum(questionnaire.credit!.products!)
        // .map(x => x.price).length > 0 ? questionnaire.credit.products!.map(x => x.price)!
        //     .reduce((a, b) => numOr0(a) + numOr0(b))!.toFixed(2).toString()
        // : '0'
        this.statuses = (
            <span
                className={getQuestionnaireStatusClass(questionnaire.status)}
            >
                {getQuestionnaireStatusTextForList(questionnaire.status)}
            </span>
        )
        this.pin = questionnaire.client.passport ? questionnaire.client.passport!.pin : ''
        this.passportNumber = questionnaire.client.passport ? questionnaire.client.passport.number : ''
        this.passportSeries = questionnaire.client.passport ? questionnaire.client.passport.series : ''
        this.salary = _.round(questionnaire.client.salary, 2)
        this.revenue = _.round(questionnaire.client.revenue, 2)
        this.email = questionnaire.client.email
        this.birthday = DateTimeHelper.formatDateForList(questionnaire.client.birthday)
        this.age = DateTimeHelper.getFullYearsFromDate(questionnaire.client.birthday)
        this.creditNumber = questionnaire.credit.creditNumber
        this.phones = PhoneHelper.convertToString(questionnaire.client.phones)
        this.products = ProductHelper.convertToString(questionnaire.credit.products)
        this.orderSource = questionnaire.orderSource
        this.creditDuration = questionnaire.credit.creditCondition.termCountMonths
        this.creditBodySum = getCreditBodySum(
            scheduleArr,
            questionnaire.credit.creditCondition.prepaymentSum)
        this.paymentPerMonth = getPaymentPerMonth(scheduleArr)
        this.prepaymentSum = _.round(questionnaire.credit.creditCondition.prepaymentSum, 2)
        this.lastComment = CommentHelper.getLastComment(questionnaire.comments)
        this.inProgressByUserId = questionnaire.inProgressByUserId
        this.penalty = penalty
        this.currentDebtByCreditBody =
            getCurrentDebtByCreditBody(
                questionnaire.credit.creditDetail.balance,
                scheduleArr,
                questionnaire.credit.creditCondition.prepaymentSum)
        this.currentDebt = getCurrentDebt(
            questionnaire.credit.creditDetail.balance,
            scheduleArr,
            questionnaire.credit.creditCondition.prepaymentSum,
            penalty)
        this.totalCustomerPayments = getPaymentsSum(questionnaire.credit.payments) - getFeeSum(questionnaire.credit.payments)
        this.workDescription = questionnaire.client.workDescription ?
            questionnaire.client.workDescription.replace(/\r/g, '').replace(/\n/g, '') : ''
        this.affiliateName = questionnaire.affiliate ? questionnaire.affiliate.name : ''
        this.merchantName = questionnaire.affiliate && questionnaire.affiliate.merchant ?
            questionnaire.affiliate.merchant.name : ''
        this.externalKey = questionnaire.externalKey
        this.troubleEventsCount = questionnaire.credit['troubleEvents'].length
        this.troubleEventsByType = JSON.stringify(
            _.groupBy(questionnaire.credit['troubleEvents'], (x) => { return x.type }))
        this.cancelReason =
            questionnaire.cancelReason ?
                LocalizationStore.getInstance().t(CancelReason[questionnaire.cancelReason]) :
                ''
        this.agentCode = questionnaire.agentCode
        this.agentAction = questionnaire.agentAction
        this.isNeedToVerify = LocalizationStore.getInstance().t(`isNeedToVerifyClient${questionnaire.client.isNeedToVerify ? "True" : "False"}`)
        this.paidFee = getFeeSum(questionnaire.credit.payments)
    }

    id: string
    date: string
    name: string
    sum: number
    statuses: React.ReactNode
    pin: string
    passportNumber: string
    passportSeries: string
    salary: number
    revenue: number
    email?: string
    birthday: string
    age: number | null
    creditNumber: string
    phones: string
    products: string
    orderSource: string
    creditDuration: number
    creditBodySum: number
    prepaymentSum: number
    paymentPerMonth: number
    lastComment: string
    inProgressByUserId: string
    penalty: number
    currentDebtByCreditBody: number
    currentDebt: number
    totalCustomerPayments: number
    workDescription: string
    affiliateName: string
    merchantName: string
    externalKey: string
    troubleEventsCount: number
    troubleEventsByType: string
    cancelReason: string
    agentCode: string
    agentAction: string
    isNeedToVerify: string
    paidFee: number
}

export function createColumns() {
    const localizationStore = LocalizationStore.getInstance()
    let optionsQStatuses = EnumHelpers.toKeyValueArray(QuestionnaireStatus)
    let optionsCancelReasons = EnumHelpers.toKeyValueArray(CancelReason)

    return [
        {
            Header: localizationStore.t('Trouble-events amount'),
            accessor: 'troubleEventsByType',
            maxWidth: 300,
            minWidth: 100,
            sortable: false,
            filterable: false,
            Cell: (cellInfo: CellInfo) => {
                let data = JSON.parse(cellInfo.row.troubleEventsByType)
                let totalCount = 0
                let beforeresponsibilityCount = 0

                Object.keys(data).forEach(key => {
                    totalCount += data[key].length

                    if (parseInt(key, 10) === TroubleEventType.SmsBeforeResponsibility) {
                        beforeresponsibilityCount += data[key].length
                    }
                })

                if (!totalCount) {
                    return (
                        <div>
                            <FontAwesome.FaCheckCircle
                                color="#3EC412"
                                size={14}
                            />&nbsp;
                            <span>0</span>
                        </div>
                    )
                } else if (totalCount - beforeresponsibilityCount === 0) {
                    return (
                        <div>
                            <FontAwesome.FaExclamationCircle
                                color="#ffc107"
                                size={14}
                            />&nbsp;
                            <span className="font-weight-bold">
                                {totalCount}
                            </span>
                        </div>
                    )
                } else {
                    return (
                        <div>
                            <FontAwesome.FaExclamationCircle
                                color="#dc3545"
                                size={14}
                            />&nbsp;
                            <span className="font-weight-bold">
                                {totalCount}
                            </span>
                        </div>
                    )
                }
            }
        },
        {
            Header: localizationStore.t('PID'),
            maxWidth: 500,
            minWidth: 100,
            accessor: 'id',
            sortable: false,
            Cell: (cellInfo: CellInfo) => (
                <Link
                    className="qDetailLink"
                    to={'/questionnaire/' + cellInfo.row.id}
                    id={cellInfo.row.name}
                >
                    {cellInfo.row.id}
                </Link>
            )
        },
        {
            Header: localizationStore.t('date'),
            accessor: 'date',
            maxWidth: 300,
            minWidth: 100,
            sortable: false
        },
        {
            Header: localizationStore.t('Full name'),
            accessor: 'name',
            maxWidth: 500,
            minWidth: 200,
            sortable: false
        },
        {
            Header: localizationStore.t('creditNumber'),
            maxWidth: 330,
            minWidth: 100,
            accessor: 'creditNumber',
            filterable: true,
            sortable: false,
        },

        {
            Header: localizationStore.t('status'),
            accessor: 'statuses',
            maxWidth: 200,
            minWidth: 145,
            filterable: true,
            sortable: false,
            filterMethod: (filter: any, row: any) => {
                if (optionsQStatuses[filter.id]) {
                    return row[filter.id]
                } else {
                    return true
                }
            },
            Filter: (params: { filter: any, onChange: any }) => {
                return (
                    <div className="rt-th">
                        <select
                            onChange={event => params.onChange(event.target.value)}
                            style={{ height: '32px', width: '100%' }}
                        >
                            <option key={'all'} value={''}>
                                {localizationStore.t('Show all')}
                            </option>

                            {
                                optionsQStatuses.map(x => {
                                    return (
                                        <option key={x.value} value={x.value}>
                                            {getQuestionnaireStatusTextForList(QuestionnaireStatus[x.key])}
                                        </option>
                                    )
                                })
                            }
                        </select>
                    </div>
                )
            }
        },
        {
            Header: localizationStore.t('pin'),
            accessor: 'pin',
            maxWidth: 200,
            minWidth: 145,
            filterable: true,
            sortable: false,
        }
        ,
        {
            Header: localizationStore.t('email'),
            accessor: 'email',
            maxWidth: 350,
            minWidth: 200,
            filterable: true,
            sortable: false,
        },
        {
            Header: localizationStore.t('passportNumber'),
            accessor: 'passportNumber',
            maxWidth: 200,
            minWidth: 145,
            filterable: true,
            sortable: false,
        }
        ,
        {
            Header: localizationStore.t('passportSeries'),
            accessor: 'passportSeries',
            maxWidth: 200,
            minWidth: 145,
            filterable: true,
            sortable: false,
        }
        ,
        {
            Header: localizationStore.t('birthday'),
            accessor: 'birthday',
            maxWidth: 200,
            minWidth: 145,
            filterable: true,
            sortable: false,
        },
        {
            Header: localizationStore.t('age'),
            accessor: 'age',
            maxWidth: 200,
            minWidth: 145,
            filterable: true,
            sortable: false,
        },
        {
            Header: localizationStore.t('salary'),
            accessor: 'salary',
            maxWidth: 200,
            minWidth: 145,
            filterable: true,
            sortable: false,
        }
        ,
        {
            Header: localizationStore.t('revenue'),
            accessor: 'revenue',
            maxWidth: 200,
            minWidth: 145,
            filterable: true,
            sortable: false,
        }
        ,
        {
            Header: localizationStore.t('phones'),
            maxWidth: 330,
            minWidth: 100,
            accessor: 'phones',
            filterable: true,
            sortable: false,
        },
        {
            Header: localizationStore.t('products'),
            maxWidth: 330,
            minWidth: 100,
            accessor: 'products',
            filterable: true,
            sortable: false,
        },
        {
            Header: localizationStore.t('creditDuration'),
            maxWidth: 330,
            minWidth: 100,
            accessor: 'creditDuration',
            filterable: true,
            sortable: false,
        },
        {
            Header: localizationStore.t('Sum'),
            accessor: 'sum',
            maxWidth: 300,
            minWidth: 100,
            filterable: true,
            sortable: false
        },
        {
            Header: localizationStore.t('prepaymentSum'),
            maxWidth: 330,
            minWidth: 100,
            accessor: 'prepaymentSum',
            filterable: true,
            sortable: false,
        },
        {
            Header: localizationStore.t('creditBodySum'),
            maxWidth: 330,
            minWidth: 100,
            accessor: 'creditBodySum',
            filterable: false,
            sortable: false,
        },
        {
            Header: localizationStore.t('paymentPerMonth'),
            maxWidth: 330,
            minWidth: 100,
            accessor: 'paymentPerMonth',
            filterable: false,
            sortable: false,
        },
        {
            Header: localizationStore.t('totalCustomerPayments'),
            maxWidth: 330,
            minWidth: 100,
            accessor: 'totalCustomerPayments',
            filterable: false,
            sortable: false,
        },
        {
            Header: localizationStore.t('paidFee'),
            maxWidth: 330,
            minWidth: 100,
            accessor: 'paidFee',
            filterable: false,
            sortable: false,
        },
        {
            Header: localizationStore.t('CurrentDebt'),
            maxWidth: 330,
            minWidth: 100,
            accessor: 'currentDebt',
            filterable: false,
            sortable: false,
        },
        {
            Header: localizationStore.t('penalty'),
            maxWidth: 330,
            minWidth: 100,
            accessor: 'penalty',
            filterable: false,
            sortable: false,
        },
        {
            Header: localizationStore.t('currentDebtByCreditBody'),
            maxWidth: 330,
            minWidth: 100,
            accessor: 'currentDebtByCreditBody',
            filterable: false,
            sortable: false,
        },

        {
            Header: localizationStore.t('workDescription'),
            accessor: 'workDescription',
            maxWidth: 500,
            minWidth: 330,
            filterable: false,
            sortable: false,
        }
        ,
        {
            Header: localizationStore.t('isNeedToVerifyClient'),
            accessor: 'isNeedToVerify',
            maxWidth: 200,
            minWidth: 145,
            filterable: true,
            sortable: false,
            Filter: (params: { filter: any, onChange: any }) => {
                return (
                    <div className="rt-th">
                        <select
                            onChange={event => params.onChange(event.target.value)}
                            style={{ height: '32px', width: '100%' }}
                        >
                            <option key={'all'} value={''}>
                                {localizationStore.t('Show all')}
                            </option>

                            {
                                [
                                    (<option key={"true"} value="true">
                                        {localizationStore.t('isNeedToVerifyClientTrue')}
                                    </option>),
                                    (<option key={"false"} value="false">
                                        {localizationStore.t('isNeedToVerifyClientFalse')}
                                    </option>)
                                ]
                            }
                        </select>
                    </div>
                )
            }
        }
        ,
        {
            Header: localizationStore.t('orderSource'),
            accessor: 'orderSource',
            maxWidth: 200,
            minWidth: 145,
            filterable: true,
            sortable: false,
        },
        {
            Header: localizationStore.t('externalKey'),
            accessor: 'externalKey',
            maxWidth: 200,
            minWidth: 145,
            filterable: true,
            sortable: false,
        },
        {
            Header: localizationStore.t('affiliate'),
            accessor: 'affiliateName',
            maxWidth: 200,
            minWidth: 145,
            filterable: true,
            sortable: false,
        }
        ,
        {
            Header: localizationStore.t('Merchant'),
            accessor: 'merchantName',
            maxWidth: 200,
            minWidth: 145,
            filterable: true,
            sortable: false,
        }
        ,
        {
            Header: localizationStore.t('agentCode'),
            accessor: 'agentCode',
            maxWidth: 200,
            minWidth: 145,
            filterable: true,
            sortable: false,
        }
        ,
        {
            Header: localizationStore.t('agentAction'),
            accessor: 'agentAction',
            maxWidth: 200,
            minWidth: 145,
            filterable: true,
            sortable: false,
        }
        ,
        {
            Header: localizationStore.t('cancelReason'),
            accessor: 'cancelReason',
            maxWidth: 200,
            minWidth: 145,
            filterable: true,
            sortable: false,
            filterMethod: (filter: any, row: any) => {
                if (optionsCancelReasons[filter.id]) {
                    return row[filter.id]
                } else {
                    return true
                }
            },
            Filter: (params: { filter: any, onChange: any }) => {
                return (
                    <div className="rt-th">
                        <select
                            onChange={event => params.onChange(event.target.value)}
                            style={{ height: '32px', width: '100%' }}
                        >
                            <option key={'all'} value={''}>
                                {localizationStore.t('Show all')}
                            </option>

                            {
                                optionsCancelReasons.map(x => {
                                    return (
                                        <option key={x.value} value={x.value}>
                                            {localizationStore.t(x.key)}
                                        </option>
                                    )
                                })
                            }
                        </select>
                    </div>
                )
            }
        }
        ,
        {
            Header: localizationStore.t('lastComment'),
            maxWidth: 450,
            minWidth: 200,
            accessor: 'lastComment',
            filterable: true,
            sortable: false,
        },
        {
            Header: localizationStore.t('inProgressByUserId'),
            accessor: 'inProgressByUserId',
            Cell: (cellInfo: CellInfo) => (
                <Link
                    className="userDetailLink"
                    to={'/user/' + cellInfo.row.inProgressByUserId}
                    id={cellInfo.row.inProgressByUserId}
                >
                    {cellInfo.row.inProgressByUserId}
                </Link>
            ),
            maxWidth: 400,
            minWidth: 100,
            filterable: true,
            sortable: false,
        }
    ]
}

export function createStub(data: Array<IQuestionnaire>) {
    return data.map(q => {
        try {
            return new QuestionnaireTableItem(q)
        } catch (ex) {
            console.error(ex)
            return undefined
        }
    }
    ).filter(x => x)
}

export function onFetchQuestionnairesDataAll(state: any, instance: any) {
    HttpActionsService
        .getInstance()
        .getQuestionnaires(null, state.page, state.pageSize, state.filtered, state.sorted)
}

export function onFetchQuestionnairesDataDraft(state: any, instance: any) {
    HttpActionsService
        .getInstance()
        .getQuestionnaires(
            [QuestionnaireStatus.Draft],
            state.page,
            state.pageSize,
            state.filtered,
            state.sorted)
}

export function onFetchQuestionnairesDataInProgressCreditConsultant(state: any, instance: any) {

    const userStore = UserStore.getInstance()
    let filterClone = _.cloneDeep(state.filtered)
    if (!(userStore.checkAdmin || userStore.checkCollectionGroupAdministrator || userStore.checkSuperAdmin)) {
        filterClone.push({
            id: 'inProgressByUserId',
            value: userStore.id
        })
    }

    HttpActionsService
        .getInstance()
        .getQuestionnaires(
            [QuestionnaireStatus.InProgressCreditConsultant],
            state.page,
            state.pageSize,
            filterClone,
            state.sorted)
}

export function onFetchQuestionnairesDataInProgressCreditExpert(state: any, instance: any) {
    const userStore = UserStore.getInstance()
    let filterClone = _.cloneDeep(state.filtered)
    if (!(userStore.checkAdmin || userStore.checkCollectionGroupAdministrator || userStore.checkSuperAdmin)) {
        filterClone.push({
            id: 'inProgressByUserId',
            value: userStore.id
        })
    }

    HttpActionsService
        .getInstance()
        .getQuestionnaires(
            [QuestionnaireStatus.InProgressCreditExpert],
            state.page,
            state.pageSize,
            filterClone,
            state.sorted)
}

export function onFetchQuestionnairesDataScored(state: any, instance: any) {
    HttpActionsService
        .getInstance()
        .getQuestionnaires(
            [QuestionnaireStatus.Scored],
            state.page,
            state.pageSize,
            state.filtered,
            state.sorted)
}

export function onFetchHistoryQuestionnairesData(state: any, instance: any) {
    HttpActionsService
        .getInstance()
        .getHistoryQuestionnaires(state.page, state.pageSize, state.filtered, state.sorted)
}

export function onFetchFindQuestionnairesData(state: any, instance: any) {
    let q = toJS(QuestionnairesStore.getInstance().getItem)

    if (!q) {
        return
    }

    let request = new FindQRequest(
        q.client.passport.number,
        q.client.passport.pin,
        [q.id],
        state.page,
        state.pageSize,
        state.filtered,
        state.sorted
    )

    HttpActionsService
        .getInstance()
        .findQuestionnaires(request)
}

export function getQuestionnairesTable() {
    const localizationStore = LocalizationStore.getInstance()
    const questionnairesStore = QuestionnairesStore.getInstance()
    const configStore = ConfigStore.getInstance()

    return (
        <ReactTable
            pages={questionnairesStore.listByTypeAndPageCount.All.pageCount}
            data={createStub(questionnairesStore.listByTypeAndPageCount.All.items)}
            columns={createColumns()}
            defaultPageSize={configStore.getPageSize}
            className="-striped -highlight"
            noDataText={localizationStore.t('No data text')}
            filterable={true}
            pageSizeOptions={[5, 10, 20, 25, 50, 100]}
            previousText={localizationStore.t('Previous')}
            nextText={localizationStore.t('Next')}
            pageText={localizationStore.t('Page')}
            ofText={localizationStore.t('of')}
            manual
            onFetchData={_.debounce(onFetchQuestionnairesDataAll, 777)}
        />
    )
}

export function getQuestionnairesTableDraft() {
    const localizationStore = LocalizationStore.getInstance()
    const questionnairesStore = QuestionnairesStore.getInstance()
    const configStore = ConfigStore.getInstance()

    return (
        <ReactTable
            pages={questionnairesStore.listByTypeAndPageCount.Draft.pageCount}
            data={createStub(questionnairesStore.listByTypeAndPageCount.Draft.items)}
            columns={createColumns()}
            defaultPageSize={configStore.getPageSize}
            className="-striped -highlight"
            noDataText={localizationStore.t('No data text')}
            filterable={true}
            pageSizeOptions={[5, 10, 20, 25, 50, 100]}
            previousText={localizationStore.t('Previous')}
            nextText={localizationStore.t('Next')}
            pageText={localizationStore.t('Page')}
            ofText={localizationStore.t('of')}
            manual
            onFetchData={_.debounce(onFetchQuestionnairesDataDraft, 777)}
        />
    )
}

export function getQuestionnairesTableScored() {
    const localizationStore = LocalizationStore.getInstance()
    const questionnairesStore = QuestionnairesStore.getInstance()
    const configStore = ConfigStore.getInstance()

    return (
        <ReactTable
            pages={questionnairesStore.listByTypeAndPageCount.Scored.pageCount}
            data={createStub(questionnairesStore.listByTypeAndPageCount.Scored.items)}
            columns={createColumns()}
            defaultPageSize={configStore.getPageSize}
            className="-striped -highlight"
            noDataText={localizationStore.t('No data text')}
            filterable={true}
            pageSizeOptions={[5, 10, 20, 25, 50, 100]}
            previousText={localizationStore.t('Previous')}
            nextText={localizationStore.t('Next')}
            pageText={localizationStore.t('Page')}
            ofText={localizationStore.t('of')}
            manual
            onFetchData={_.debounce(onFetchQuestionnairesDataScored, 777)}
        />
    )
}

export function getQuestionnairesTableInProgressByCreditConsultant() {
    const localizationStore = LocalizationStore.getInstance()
    const questionnairesStore = QuestionnairesStore.getInstance()
    const configStore = ConfigStore.getInstance()

    return (
        <ReactTable
            pages={questionnairesStore.listByTypeAndPageCount.InProgressCreditConsultant.pageCount}
            data={createStub(questionnairesStore.listByTypeAndPageCount.InProgressCreditConsultant.items)}
            columns={createColumns()}
            defaultPageSize={configStore.getPageSize}
            className="-striped -highlight"
            noDataText={localizationStore.t('No data text')}
            filterable={true}
            pageSizeOptions={[5, 10, 20, 25, 50, 100]}
            previousText={localizationStore.t('Previous')}
            nextText={localizationStore.t('Next')}
            pageText={localizationStore.t('Page')}
            ofText={localizationStore.t('of')}
            manual
            onFetchData={_.debounce(onFetchQuestionnairesDataInProgressCreditConsultant, 777)}
        />
    )
}

export function getQuestionnairesTableInProgressByCreditExpert() {
    const localizationStore = LocalizationStore.getInstance()
    const questionnairesStore = QuestionnairesStore.getInstance()
    const configStore = ConfigStore.getInstance()

    return (
        <ReactTable
            pages={questionnairesStore.listByTypeAndPageCount.InProgressCreditExpert.pageCount}
            data={createStub(questionnairesStore.listByTypeAndPageCount.InProgressCreditExpert.items)}
            columns={createColumns()}
            defaultPageSize={configStore.getPageSize}
            className="-striped -highlight"
            noDataText={localizationStore.t('No data text')}
            filterable={true}
            pageSizeOptions={[5, 10, 20, 25, 50, 100]}
            previousText={localizationStore.t('Previous')}
            nextText={localizationStore.t('Next')}
            pageText={localizationStore.t('Page')}
            ofText={localizationStore.t('of')}
            manual
            onFetchData={_.debounce(onFetchQuestionnairesDataInProgressCreditExpert, 777)}
        />
    )
}

export function getHistoryQuestionnairesTable() {
    const localizationStore = LocalizationStore.getInstance()
    const questionnairesStore = QuestionnairesStore.getInstance()
    const configStore = ConfigStore.getInstance()

    return (
        <ReactTable
            pages={questionnairesStore.listByTypeAndPageCount.All.pageCount}
            data={createStub(questionnairesStore.listByTypeAndPageCount.All.items)}
            columns={createColumns()}
            defaultPageSize={configStore.getPageSize}
            className="-striped -highlight"
            noDataText={localizationStore.t('No data text')}
            filterable={true}
            pageSizeOptions={[5, 10, 20, 25, 50, 100]}
            previousText={localizationStore.t('Previous')}
            nextText={localizationStore.t('Next')}
            pageText={localizationStore.t('Page')}
            ofText={localizationStore.t('of')}
            manual
            onFetchData={_.debounce(onFetchHistoryQuestionnairesData, 777)}
        />
    )
}

export function getFindQuestionnairesTable() {
    const localizationStore = LocalizationStore.getInstance()
    const questionnairesStore = QuestionnairesStore.getInstance()
    // const configStore = ConfigStore.getInstance()

    return (
        <div className="findQBlock">
            <p className="font-weight-bold text-center">{localizationStore.t('PREVIOUS QUESTIONNAIRES')}</p>
            <div>
                <ReactTable
                    pages={questionnairesStore.listByTypeAndPageCount.Find.pageCount}
                    data={createStub(questionnairesStore.listByTypeAndPageCount.Find.items)}
                    columns={createColumns()}
                    defaultPageSize={5}
                    className="-striped -highlight"
                    noDataText={localizationStore.t('No data text')}
                    filterable={true}
                    pageSizeOptions={[5, 10, 20, 25, 50, 100]}
                    previousText={localizationStore.t('Previous')}
                    nextText={localizationStore.t('Next')}
                    pageText={localizationStore.t('Page')}
                    ofText={localizationStore.t('of')}
                    manual
                    onFetchData={_.debounce(onFetchFindQuestionnairesData, 777)}
                />
            </div>
            <p className="font-weight-italic text-right">{localizationStore.t('Filter by Previous questionnaires')}</p>
        </div>
    )
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Model/QuestionnaireTableModel.tsx